export const SHIELDS_BY_DEVICE_ID = 'SHIELDS_BY_DEVICE_ID';
export const DEVICES_BY_SHIELD_ID = 'DEVICES_BY_SHIELD_ID';
export const DEVICES_BY_USER_ID = 'DEVICES_BY_USER_ID';
export const SHIELDS_BY_USER_ID = 'SHIELDS_BY_USER_ID';
